export enum ColumnType {
    DATE = 'DATE',
    DATETIME = 'DATETIME',
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    MONTH = 'MONTH',
    NATIONALITY = 'NATIONALITY',
}

export interface IColumn {
    name: string;
    label: string;
    type: ColumnType;
    hidden: boolean;
}
